module.exports = __webpack_public_path__ + "static/media/chanMan01.178b8f76.JPG";